import React, {
  useEffect,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';

const H3 = styled.h3`
  color: #748495;
  font-size: 42px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 2em;
  margin-top: 60px;
`;

const Form = styled.form`
  width: 350px;
  margin: 0 auto;
`;

const LoginButton = styled.button`
  margin: 15px auto;
`;

const SignUpDiv = styled.div`
  width: 350px;
  height: 50px;
  margin: auto;
  padding-top: 15px;
  border-top: 1px dashed #B4C1CD;
  margin-top: 30px;
`;

const DISMISS_LAST_ALERT_TIMEOUT = 1000;

const LoginContainer = ({
  actions: {
    createSuccessAlert,
    dismissLastAlert,
    logIn,
    getMetadata,
    getUserProfile,
  },
  router: { navigate },
  user: { isLoggedIn },
}) => {
  const emailRef = useRef();
  const passwordRef = useRef();

  useEffect(() => {
    // redirect user to dashboard if they are loggedIn already
    if (isLoggedIn) {
      navigate('/dashboard', { trigger: true });
    }
  }, [isLoggedIn, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();

    await logIn(
      emailRef.current.value,
      passwordRef.current.value,
      {
        onSucceed: async () => {
          createSuccessAlert(i18n.t('loginSucceedMsg'));

          // automatically dismiss the success alert
          setTimeout(() => {
            dismissLastAlert();
          }, DISMISS_LAST_ALERT_TIMEOUT);

          // get app metadata which is used everywhere.
          await getMetadata();

          // after successful login,
          // we aggressively fetch the profile data for other components to use
          if (await getUserProfile()) {
            navigate('/dashboard', { trigger: true });
          }
        },
      },
    );
  };

  return (
    <div className="LoginContainer" style={{ height: 720 }}>
      <H3>
        {i18n.t('login')}
      </H3>
      <Form onSubmit={onSubmit}>
        <div className="form-group">
          <input
            id="email"
            className="form-control"
            type="text"
            ref={emailRef}
          />
        </div>
        <div className="form-group">
          <input
            id="password"
            className="form-control"
            type="password"
            ref={passwordRef}
          />
        </div>
        <p>
          {i18n.t('forgotPwd_qus')} <a href="/forgot">{i18n.t('forgot')}</a>
        </p>
        <div className="form-group clearfix">
          <LoginButton className="btn boca-btn btn-block" style={{ width: '100%' }}>
            {i18n.t('login')}
          </LoginButton>
        </div>
      </Form>
      <SignUpDiv>
        <p>
          {i18n.t('orBecomeAMember')}
        </p>
        <p>
          <a href="/signup" className="btn-sec">
            {i18n.t('register').toUpperCase()}
          </a>
        </p>
      </SignUpDiv>
    </div>
  );
};

LoginContainer.propTypes = {
  actions: PropTypes.shape({
    createSuccessAlert: PropTypes.func.isRequired,
    dismissLastAlert: PropTypes.func.isRequired,
    getMetadata: PropTypes.func.isRequired,
    getUserProfile: PropTypes.func.isRequired,
    logIn: PropTypes.func.isRequired,
  }).isRequired,
  router: PropTypes.shape({
    navigate: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    isLoggedIn: PropTypes.bool.isRequired,
  }).isRequired,
};

LoginContainer.defaultProps = {};

export default connectActionsAndReducers(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/login/LoginContainer.js